export default __webpack_public_path__ + "static/media/Golden Visa - Benefits.7176e4e2.jpg";